import { Country } from '@/domain/country/Country';

export interface CountryDataSet {
  id: string;
  name: string;
}

export const toCountryDataSet = (country: Country): CountryDataSet => {
  return { id: country.id, name: country.name };
};
